import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"download-btn white--text",attrs:{"outlined":"","small":"","color":"indigo"},on:{"click":function($event){return _vm.copy()}}},[_c(VIcon,{attrs:{"dark":"","small":""}},[_vm._v("mdi-pencil")]),_vm._v("\n    Copy URL\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }